import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import {
  AfterContentInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChild,
  DestroyRef,
  HostBinding,
  Input,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';
import { Observable, merge, of } from 'rxjs';
import { InputDirective } from '../directives';

@Component({
  selector: 'cf-form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [NgClass, AsyncPipe, NgIf],
})
export class FormFieldComponent implements AfterContentInit {
  @HostBinding('class') classes = 'cf-form-field';

  @Input() classNames!: string;

  @Input() hasSuccess = false;

  @ContentChild(InputDirective) inputDir!: InputDirective;

  private destroyRef = inject(DestroyRef);

  constructor(private cdr: ChangeDetectorRef) {}

  get isTouched(): boolean {
    return this.inputDir?.ngControl?.control?.touched ?? false;
  }

  get hasErrors$(): Observable<boolean> {
    return this.inputDir?.hasErrors$;
  }

  get isInvalid(): boolean {
    return this.inputDir?.ngControl?.control?.invalid ?? false;
  }

  get disabled$(): Observable<boolean> {
    const control = this.inputDir?.ngControl?.control as FormControl;
    if (control) {
      return of(control.disabled);
    }
    return of(false);
  }

  get hasError(): boolean {
    return (this.isInvalid && this.isTouched) ?? false;
  }

  ngAfterContentInit(): void {
    const control = this.inputDir?.ngControl?.control as FormControl;

    if (control) {
      merge(control.valueChanges, control.statusChanges)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(() => {
          this.cdr.markForCheck();
        });
    }
  }
}
